module.exports = __webpack_public_path__ + "static/media/corporate-services-img22.198ef8c5.jpg";